\:host
    width: 100%

.CartWrapper
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: space-between
    padding: 0
    font-size: 14px
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    .ListItem
        height: 45px
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        width: 100%
        box-sizing: border-box
        padding: 0 10px
        &:not(:first-child)
            border-top: 1px solid rgb($globalSettingsStrokeSecondary)

    .TextContainer
        width: 100%

.ItemContainer
    width: 100%
    .DividerContainer
        width: calc(100% + 40px)
        margin: 0 -20px

.DetailsContainer
    width: 100%
